import uuidService from '@/services/uuid.service';
import { ICalendarEvent } from '@/types/calendar-event/ICalendarEvent';
import { Optional } from 'utility-types';

/**
 * Represents a calendar that has not been saved yet.
 * It is equivalent to a ICalendarEvent but with some non defined properties
 */
export type ILocalCalendarEvent = Optional<ICalendarEvent, 'calendarId'>;

function createLocalCalendarEvent(args: Partial<ICalendarEvent>): ILocalCalendarEvent {
	const id = uuidService.v4();

	return {
		id,
		attendees: [],
		attachments: [],
		comments: [],
		description: '',
		interval: null,
		locations: [],
		status: 'CONFIRMED',
		summary: '',
		tags: {},
		...args,
	};
}

export default { createLocalCalendarEvent };
